import { normalizePolylineForDateline } from './math.js';

/**
 * Leaflet [lat, lng] pairs for a ship's held (pending) departure, or null.
 * Uses the waypoints stored on pendingDeparture; Ship.getPendingRoute()
 * covers older saves (computed once, cached on the ship).
 */
export function getPlannedLatLngs(ship) {
  if (!ship?.pendingDeparture || ship.currentRoute) return null;
  const wps = ship.pendingDeparture.waypoints || ship.getPendingRoute?.()?.waypoints;
  if (!Array.isArray(wps) || wps.length < 2) return null;
  return normalizePolylineForDateline(wps).map(w => [w.lat, w.lng]);
}
